import React from "react";
import { Link } from 'react-router-dom';
import "./Service.scss";

const Service = ({ serviceList }) => {
  const { title, imageUrl, description } = serviceList;

  return (
    <div className="story-reels-container">
      <div className="service-box">
        <div className="video-area">
          <img src={imageUrl} alt={title} />
        </div>

        <div className="service-text">
          <h3>{title}</h3>
          <p>{description}</p>
          <Link 
            to={`/services/${serviceList.slug}`} 
            className="know-more-service-btn"
          >
            Know more
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Service;
